'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'circle-1';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0ee';
var svgPathData = ['M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zM176 368c0-8.8 7.2-16 16-16l48 0 0-180.4-32.1 18.3c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l56-32c5-2.8 11-2.8 16 .1s8 8.1 8 13.8l0 208 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0-64 0c-8.8 0-16-7.2-16-16z', 'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 130.2c4.9 2.9 8 8.1 8 13.8l0 208 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-180.4-32.1 18.3c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l56-32c5-2.8 11-2.8 16 .1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle1 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;